<template>
  <div class="clearfix">
    <nav aria-label="Page navigation clearfix">
      <ul class="pagination">
        <li>
          <span>
            {{ $t("rec") + total }}
            {{ $t("currpage") }}{{ currentPage }}/{{ pageCount }}
          </span>
        </li>
        <li v-if="currentPage <= 1">
          <a href="javascript:;" @click="firstPage()"><span class="glyphicon glyphicon-fast-backward" style="line-height: inherit"></span></a>
          <a href="javascript:;" @click="prevPage()"><span class="glyphicon glyphicon-backward" style="line-height: inherit"></span></a>
        </li>
        <li v-for="pageIndex in end - start + 1" :class="{ active: (start+pageIndex-1) == currentPage }">
          <a href="javascript:;" @click="goToPage(start+pageIndex-1)">
            {{ start+pageIndex-1 }}
            <span v-if="(start+pageIndex-1) == currentPage" class="sr-only">({{ start+pageIndex-1 }})</span>
          </a>
        </li>

        <li>
          <a href="javascript:;" @click="nextPage()"><span class="glyphicon glyphicon-forward" style="line-height: inherit"></span></a>
        </li>
        <li>
          <a href="javascript:;" @click="lastPage()"><span class="glyphicon glyphicon-fast-forward" style="line-height: inherit"></span></a>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      current: 1,
      pageCount: 0,
      start: 0,
      end: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.current = 1;
      this.pageCount = Math.ceil(this.total / this.pageSize);
      this.initPageInfo();
    },
    nextPage() {
      if (this.current < this.pageCount) {
        this.current += 1;
      }
    },
    prevPage() {
      if (this.current > 1) {
        this.current -= 1;
      }
    },
    firstPage() {
      this.current = 1;
    },
    lastPage() {
      this.current = this.pageCount;
    },
    goToPage(page) {
      this.current = page;
    },
    initPageInfo() {
      if (this.pageCount <= 10) {
        this.start = 1;
        this.end = this.pageCount;
      } else {
        if (this.current <= 6) {
          this.start = 1;
          this.end = 10;
        } else {
          this.start = this.current - 5;
          if (this.pageCount > this.current + 4) {
            this.end = this.current + 4;
          } else {
            this.end = this.pageCount;
          }
        }
        // console.log(this.start);
        // console.log(this.end);
      }
    },
  },
  watch: {
    current(val) {
      this.initPageInfo();
      this.$emit("current-change", val);
    },
    currentPage(val) {
      this.current = val;
    },
    total(val) {
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination li > a {
  height: 34px;
}
</style>